module.exports = __webpack_public_path__ + "static/media/new-ia-with-projects.34136b67.png";